module.exports = __webpack_public_path__ + "static/media/menu_parents1454d96d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sidenav/images/menu_parents.svg
// module id = 1232
// module chunks = 0